module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_BEC.0e4691b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_BEC.png
// module id = 48
// module chunks = 0